import { put, select, takeLatest, call } from 'redux-saga/effects';
import * as actions from '../actions';
import { GET_SIGNED_TOKEN_REQUEST, GET_USER_SIGNED_TOKEN_REQUEST } from '../types';
import { getSignedToken, getUserSignedToken } from '../api';

export function* getSignedTokenRequestSaga({ payload: { onSuccess } }) {
  const {
    root: {
      addCar: {
        registrationInfo: { countryName },
      },
    },
  } = yield select();
  const payload = { countryCode: countryName };

  try {
    const {
      data: { data, success },
    } = yield call(getSignedToken, payload);

    if (!data || !success) {
      throw new Error();
    }

    onSuccess(data);
    yield put(actions.getSignedTokenSuccess(data));
  } catch (e) {
    yield put(actions.getSignedTokenFailure(e));
  }
}

export function* getUserSignedTokenRequestSaga() {
  try {
    const {
      data: { data, success },
    } = yield call(getUserSignedToken);

    if (!success) {
      throw new Error();
    }

    yield put(actions.getUserSignedTokenSuccess(data));
  } catch (e) {
    yield put(actions.getUserSignedTokenFailure(e));
  }
}

const paymentSaga = [
  takeLatest(GET_USER_SIGNED_TOKEN_REQUEST, getUserSignedTokenRequestSaga),
  takeLatest(GET_SIGNED_TOKEN_REQUEST, getSignedTokenRequestSaga),
];

export default paymentSaga;
